import React, { useEffect, useMemo, useState } from "react";
import { getStripeToken } from "../../api/index.js";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import config from '@/config';
import Loader from "../../components/Loader.jsx";
import {
  ConnectComponentsProvider,
  ConnectPaymentDetails,
} from "@stripe/react-connect-js";

const PaymentModal = ({ paymentIntentID, setClose }) => {
  const [token, setToken] = useState(null);

  useEffect(() => {
    if (!token) {
      getStripeToken("payment_details").then((res) => {
        setToken(res.client_secret);
      });
    }
  }, [token]);
  useEffect(() => {
    if (paymentIntentID && token) {
      setToken(null);
    }
  }, [paymentIntentID]);

  const stripeConnectInstance = useMemo(() => {
    if (!token) {
      return null;
    }
    return loadConnectAndInitialize({
      publishableKey: config.stripe.pk,
      clientSecret: token,
    });
  }, [token]);

  if (!token || !stripeConnectInstance || !paymentIntentID) {
    return <Loader />;
  }
  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectPaymentDetails payment={paymentIntentID} onClose={setClose} />
    </ConnectComponentsProvider>
  );
};

export default PaymentModal;
